export const QUESTIONNAIRE_CURRENT_REQUEST = 'QUESTIONNAIRE_CURRENT_REQUEST';
export const QUESTIONNAIRE_CURRENT_SUCCESS = 'QUESTIONNAIRE_CURRENT_SUCCESS';
export const QUESTIONNAIRE_CURRENT_FAIL = 'QUESTIONNAIRE_CURRENT_FAIL';
export const QUESTIONNAIRE_CURRENT_RESET = 'QUESTIONNAIRE_CURRENT_RESET';

export const QUESTIONNAIRE_SAVE_ANSWER_REQUEST = 'QUESTIONNAIRE_SAVE_ANSWER_REQUEST';
export const QUESTIONNAIRE_SAVE_ANSWER_SUCCESS = 'QUESTIONNAIRE_SAVE_ANSWER_SUCCESS';
export const QUESTIONNAIRE_SAVE_ANSWER_FAIL = 'QUESTIONNAIRE_SAVE_ANSWER_FAIL';
export const QUESTIONNAIRE_SAVE_ANSWER_RESET = 'QUESTIONNAIRE_SAVE_ANSWER_RESET';

export const QUESTIONNAIRE_COMPLETE_REQUEST = 'QUESTIONNAIRE_COMPLETE_REQUEST';
export const QUESTIONNAIRE_COMPLETE_SUCCESS = 'QUESTIONNAIRE_COMPLETE_SUCCESS';
export const QUESTIONNAIRE_COMPLETE_FAIL = 'QUESTIONNAIRE_COMPLETE_FAIL';
export const QUESTIONNAIRE_COMPLETE_RESET = 'QUESTIONNAIRE_COMPLETE_RESET';

export const QUESTIONNAIRE_CHECK_ACCESS_REQUEST = 'QUESTIONNAIRE_CHECK_ACCESS_REQUEST';
export const QUESTIONNAIRE_CHECK_ACCESS_SUCCESS = 'QUESTIONNAIRE_CHECK_ACCESS_SUCCESS';
export const QUESTIONNAIRE_CHECK_ACCESS_FAIL = 'QUESTIONNAIRE_CHECK_ACCESS_FAIL';